import { BrowserRouter, Routes, Route } from "react-router-dom";
import React from 'react';

import Header from './components/Header';
import Homepage from './components/Homepage';
import Footer from './components/Footer';
import ProduitsParCollection from "./components/ProduitsParCollection";
import ReferenceImages from './components/ReferenceImages';
import CollectionsWallpapers from "./components/CollectionsWallpapers";
import CollectionsAdapanel from "./components/CollectionsAdapanel";
import CollectionsPosters from "./components/CollectionsPosters";
import CollectionsMoulures from "./components/CollectionsMoulures";
import CollectionsAdaHome from "./components/CollectionsAdaHome";
import CollectionsAdaAccessories from "./components/CollectionsAdaAccessories";
import Projects from "./components/Projects";
import AboutUs from "./components/AboutUs";
import ContactPage from "./components/ContactPage";

import './styles/main.css';

function App() {

    return (

    <BrowserRouter>
  
      <Routes>
        <>
        <Route path="/" element={
          <>
            <Header />
            <Homepage />
                  <Footer />

          </>
        } />



        <Route path="/collections/:id" element={
          <>
            <Header />
            <ProduitsParCollection />
            <Footer />

          </>
        } />

        <Route  path="/reference/:idReference" element={
          <>
            <Header forceScrolled />
            <ReferenceImages />
            <Footer />

          </>
        } />

        <Route  path="/collections/papierpeint" element={
          <>
            <Header forceScrolled />
            <CollectionsWallpapers />
            <Footer />

          </>
        } />

        <Route  path="/collections/bardage" element={
          <>
            <Header forceScrolled />
            <CollectionsAdapanel />
            <Footer />

          </>
        } />


        <Route  path="/collections/poster" element={
          <>
            <Header forceScrolled />
            <CollectionsPosters />
            <Footer />

          </>
        } />

        <Route  path="/collections/moulure" element={
          <>
            <Header forceScrolled />
            <CollectionsMoulures />
            <Footer />

          </>
        } />



        <Route  path="/collections/coussinsETpoufs" element={
          <>
            <Header forceScrolled/>
            <CollectionsAdaHome/>
            <Footer />

          </>
        } />

        <Route  path="/collections/accessoires" element={
          <>
            <Header forceScrolled/>
            <CollectionsAdaAccessories/>
            <Footer />

          </>
        } />


        <Route  path="/projets" element={
          <>
            <Header forceScrolled/>
            <Projects/>
            <Footer />

          </>
        } />
        

        <Route  path="/a-propos" element={
          <>
            <Header />
            <AboutUs/>
            <Footer />

          </>
        } />

        <Route  path="/contact" element={
          <>
            <Header />
            <ContactPage/>
            <Footer />

          </>
        } />


        </>
      </Routes>
    </BrowserRouter>
  );
}

export default App;